/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import {FormattedDate} from 'react-intl';
import {FormattedTime} from 'react-intl';

class PostSource extends React.Component {
    render() {
        let InputIcon = null,
            input = this.props.input,
            date = this.props.date,
            dateTime = '';

        /**
         * The icon for the input type (RSS, Twitter, etc)
         * Pinterest is determined by subtype
         *
         * @type {object}
         */
        if (input && input.subtype) {
            InputIcon = IconFactory[ConstantMixin.getIconIndexByCode(input.subtype)];
        } else {
            InputIcon = IconFactory[ConstantMixin.getIconIndexByCode(input.type)];
        }

        if (date) {
            dateTime = (
                <span>
                    {' | '}
                    <FormattedDate value={this.props.date} day="numeric" month="long" year="numeric"/> {' '}
                    <FormattedTime value={this.props.date} hour="numeric" minute="numeric"/>
                </span>
            );
        }

        return (
            <div className="item-source curate-item-source">
                <InputIcon inactive={true}/> {input.name}
                {dateTime}
                {this.props.retweet}
            </div>
        );

    }

};

PostSource.propTypes = {
    date: PropTypes.object,
    input: PropTypes.object
};

PostSource.defaultProps = {
    date: null,
    input: null
};

export default PostSource;
